var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[(_vm.activeName==0)?_c('div',{staticClass:"main"},[_c('list')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }